import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, delay, filter, takeUntil } from 'rxjs/operators';
import { AnimationLib } from 'src/app/shared/libraries/animations/animation-lib';

@Component({
  selector: 'app-message-toggle',
  templateUrl: './message-toggle.component.html',
  styleUrls: ['./message-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('show', [
      transition(':enter', [
        useAnimation(AnimationLib.fadeIn, {
          params: {
            duration: 300
          }
        })
      ]),
      transition(':leave', [
        useAnimation(AnimationLib.fadeOut, {
          params: {
            duration: 300
          }
        })
      ])
    ])
  ]
})
export class MessageToggleComponent implements OnInit, OnDestroy {

  @Input()
  type: 'notification' | 'message' | 'warning' | 'error' = 'message';

  @Input()
  theme: 'light' | 'dark' = 'light';

  @Input()
  icon: string;

  @Input()
  showDelay = 0;

  @Input()
  hideDelay = 5000;

  @Input()
  dismiss = false;

  @Input()
  toggleStyle: 'flat' | 'rounded' = 'rounded';

  @Input()
  public get shown() {
    return this._shown;
  }
  public set shown(value) {
    if (this._shown !== value) {
      this._shown = value;
      this.shownSubject.next(value);
      this.changeRef.markForCheck();
    }
  }

  @Output()
  handleDismiss = new Subject();

  private _shown = true;
  private shownSubject = new Subject<boolean>();
  private ngUnsubscribe = new Subject();

  constructor(private changeRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.initViewShownListeners();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleDismissClicked() {
    this.handleDismiss.next();
  }

  private initViewShownListeners() {
    // set hidden after delay
    this.shownSubject
      .pipe(
        debounceTime(this.hideDelay),
        filter((shown) => shown),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this._shown = false;
        this.changeRef.markForCheck();
      });
  }

}
